//Styles

import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import RenderFormulaButtons from "./RenderFormulaClose"
import RenderFormulaConnector from "./RenderFormulaConnector"

export default function RenderFormulaValue({
  formulaOrder,
  dndRef,
  dndStyle,
  dndAttributes,
  dndListeners,
  hideConnector,
  overConnectorId,
}) {
  return (
    <div
      className={`${myStyles.formulaRenderLayout} ${
        hideConnector ? myStyles.formulaRenderLayoutNoConnect : ""
      }`}
      ref={dndRef}
      style={dndStyle}
      {...dndAttributes}
      {...dndListeners}
    >
      <div
        className={`${myStyles.formulaRenderLayoutBody} ${myStyles.formulaRenderBodyQuestion}`}
      >
        {formulaOrder?.value.value}
      </div>
      {!hideConnector ? (
        <div className={myStyles.formulaRenderLayoutConnector}>
          <RenderFormulaConnector
            connector={formulaOrder.value.connectingOperator}
            formulaId={formulaOrder?.id}
            overConnectorId={overConnectorId}
          />
        </div>
      ) : null}
      <RenderFormulaButtons formulaOrderid={formulaOrder.id} />
    </div>
  )
}
